/** Shared by negotiation and trade outlook. Input is the existing moodInfo score,
 * including trait-weighted mood, player quality and club relationship. */
export const renewalInterest = (score: number, salaryCoverage = 1, money = false) => {
 const financial = Math.min(1, Math.max(-2, Math.log(Math.max(.05, salaryCoverage)))) * (money ? 1.15 : .35);
 return { interest: 1 / (1 + Math.exp(-.7 * (score + financial))), financial };
};
